// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/** Plan-Übersetzungen - Deutsch */
export const plansTranslationsDe = {
  'plans.compare.title': 'Wählen Sie Ihren Plan',
  'plans.compare.free.title': 'FREE',
  'plans.compare.foundation.title': 'FOUNDATION ⭐',
  'plans.compare.pro.title': 'PRO',
  'plans.compare.free.price': '$0 / Monat',
  'plans.compare.foundation.price': '$15 / Monat',
  'plans.compare.pro.price': '$19 / Monat',
  'plans.compare.foundation.badge': '150 limitierte Plätze',
  'plans.compare.cta.foundation': 'Founder werden',
  'plans.compare.cta.pro': 'Auf PRO upgraden',
  'plans.compare.active': 'Aktueller Plan',
  'plans.compare.limited': '',
  'plans.foundation.best_value': '',
  'plans.foundation.savings': '',
  'plans.limit.title.messages': 'Nachrichtenlimit erreicht',
  'plans.limit.message.messages': 'Sie haben das Nachrichtenlimit Ihres Plans erreicht. Wechseln Sie zu FOUNDATION oder PRO.',
  'plans.limit.title.storage': 'Speicherlimit erreicht',
  'plans.limit.message.storage': 'Sie haben das Speicherlimit erreicht. Verbessern Sie Ihren Plan für mehr Dateien.',
  'plans.limit.title.invitations': 'Einladungslimit erreicht',
  'plans.limit.message.invitations': 'Sie haben das Einladungslimit erreicht. Verbessern Sie Ihren Plan für mehr Kontakte.',
  'plans.founder.remaining': 'Noch {count} Founder-Plätze',
  'plans.founder.remaining_last': 'Letzte {count} Founder-Plätze',
  'plans.founder.remaining_limited': 'Begrenzt: noch {count} Plätze',
  'plans.founder.remaining_very_low': 'Nur noch {count} Founder-Plätze',
  'plans.founder.soldout': 'Founder ausverkauft',
  'plans.limit.reached': 'Limit erreicht — Plan verbessern',
  'plans.compare.pro.adjustment_notice': 'Der Preis kann je nach Servicebedingungen angepasst werden.',
  'plans.compare.institucional.price': 'Individuelle Preisgestaltung',
  'plans.compare.institucional.title': 'Title',
  'plans.compare.yourPlan': 'YourPlan',
  'plans.modal.title': 'Plan aktualisieren',
  'plans.modal.comparison_title': 'Planvergleich',
  'plans.modal.billing_period': '',
  'plans.modal.price_note': '',
  'plans.modal.free.line1': '30.000 Zeichen pro Monat pro Konto.',
  'plans.modal.free.line2': 'Bis zu 2 Kontakte pro Benutzer.',
  'plans.modal.free.line3': 'Bis zu 2 aktive Konversationen pro Konto.',
  'plans.modal.free.line4': 'Keine Dateianhänge und kein Speicherplatz.',
  'plans.modal.free.line5': 'Kein Datenexport.',
  'plans.modal.free.line6': 'Nachrichtenverlauf bis zu 30 Tage.',
  'plans.modal.free.line7': 'Nur 1 Gerät pro Benutzer.',
  'plans.modal.premium.line1': '300.000 Zeichen pro Monat pro Konto.',
  'plans.modal.premium.line2': 'Bis zu 100 Kontakte pro Benutzer.',
  'plans.modal.premium.line3': 'Unbegrenzte Konversationen und Chats (Tenant).',
  'plans.modal.premium.line4': 'Bis zu 50 MB Speicher (Tenant).',
  'plans.modal.premium.line5': 'Bis zu 3 Geräte pro Benutzer.',
  'plans.modal.premium.line6': 'Unbegrenzte Einladungen (Tenant).',
  'plans.modal.premium.line7': 'Umfasst Export, automatische Übersetzung und Dateien innerhalb der Planlimits.',
  'plans.modal.premium_block_heading': 'Nutzungslimits der Engine (Premium)',
  'plans.modal.foundation.ribbon': 'Founder Access',
  'plans.modal.foundation.program_title': 'Founder-Programm',
  'plans.modal.foundation.categories_title': 'Founder-Kategorien ({slots} Plätze)',
  'plans.modal.foundation.cat_legendary_title': 'LEGENDARY Founder',
  'plans.modal.foundation.cat_legendary_range': 'Position 1–25',
  'plans.modal.foundation.cat_legendary_desc': 'Die Ersten, die das Projekt unterstützt haben. Höchste historische Priorität.',
  'plans.modal.foundation.cat_early_title': 'EARLY Founder',
  'plans.modal.foundation.cat_early_range': 'Position 26–75',
  'plans.modal.foundation.cat_early_desc': 'Frühe Unterstützung mit besonderer Anerkennung.',
  'plans.modal.foundation.cat_std_title': 'Founder',
  'plans.modal.foundation.cat_std_range': 'Position 76–150',
  'plans.modal.foundation.cat_std_desc': 'Founder-Platz innerhalb der 150 Plätze.',
  'plans.modal.foundation.advantages_title': 'Founder-Vorteile',
  'plans.modal.foundation.adv1': 'Zugang zum begrenzten Founder-Pool ({slots} nummerierte Plätze).',
  'plans.modal.foundation.adv2': 'Anerkennung als Gründungsnutzer von ArChat.',
  'plans.modal.foundation.adv3': 'Founder-Badge und -Präsenz in der Produkterfahrung.',
  'plans.modal.foundation.adv4': 'Historische Priorität und Status je nach Position (1–150).',
  'plans.modal.foundation.adv5': 'Dauerhafter Vorteil gebunden an Ihren Founder-Zugang, solange die geltende Richtlinie gilt.',
  'plans.modal.pro.tagline': 'Standard-Premium — ohne Founder-Komponente',
  'plans.badges.foundation': 'Founder',
  'plans.free.title': 'FREE',
  'plans.free.subtitle': 'Kostenloser Plan',
  'plans.free.price': '$0 / Monat',
  'plans.free.features.contacts': 'Bis zu 2 Kontakte pro Nutzer',
  'plans.free.features.conversations': 'Bis zu 2 aktive Konversationen pro Konto',
  'plans.free.features.no_export': '30.000 Zeichen/Monat pro Konto; 34 Nachrichten/Tag und 1.000/Monat; kein Export',
  'plans.free.features.no_advanced': 'Keine Dateien oder Speicher; 30-Tage-Verlauf; 1 Gerät pro Nutzer',
  'plans.foundation.title': 'FOUNDATION',
  'plans.foundation.subtitle': 'Founder-Plan',
  'plans.foundation.price': '$15 / Monat',
  'plans.foundation.features.contacts': 'Gleicher Premium-Vertrag wie PRO (bis zu 100 Kontakte pro Nutzer)',
  'plans.foundation.features.conversations': 'Unbegrenzte Chats (Tenant); gleiche Limits wie PRO',
  'plans.foundation.features.badge': 'Founder-Programm (150 nummerierte Plätze)',
  'plans.foundation.features.support': 'USD 15/Monat solange Founder-Plätze verfügbar',
  'plans.pro.title': 'PRO',
  'plans.pro.subtitle': 'Pro-Plan',
  'plans.pro.price': '$19 / Monat',
  'plans.pro.features.contacts': 'Bis zu 100 Kontakte pro Nutzer',
  'plans.pro.features.conversations': 'Unbegrenzte Chats (Tenant); 1.667 Nachr./Tag, 50k/Monat',
  'plans.pro.features.export': 'Bis zu 50 MB (Tenant); Export, Übersetzung und Dateien je nach Plan',
  'plans.pro.features.notifications': 'Bis zu 3 Geräte pro Nutzer; unbegrenzte Einladungen (Tenant)',
  'plans.actions.free': 'Aktueller Plan',
  'plans.actions.foundation': 'Founder werden',
  'plans.actions.pro': 'Auf PRO upgraden',
  'plans.badges.recommended': 'EMPFOHLEN',
  'plans.badges.limited': 'LIMITIERT',
  'plans.payments_disabled.title': 'Abonnements',
  'plans.payments_disabled.message': 'Abonnements werden schrittweise freigeschaltet. Sie können die verfügbaren Pläne und ihre Vorteile einsehen.',
  'plans.payments_disabled.confirm': 'OK',
};